import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <img src={logo} className="logo" alt="Can I blend logo" />
    </div>
  );
}

export default App;
